module.exports = __webpack_public_path__ + "static/media/search-icon-grey.561f5109.svg";